var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "yxt-drawer",
    {
      attrs: {
        title: _vm.$t("pc_biz_ote_lbl_stumanage"),
        visible: _vm.isShow,
        size: "960px",
        direction: "rtl",
        "before-close": _vm.beforeClose,
      },
      on: {
        "update:visible": function ($event) {
          _vm.isShow = $event
        },
      },
    },
    [
      _c("div", { staticClass: "yxtbiz-participants-drawer" }, [
        _c(
          "div",
          { staticClass: "flex flex-mid" },
          [
            _vm._l(_vm.pageOperation, function (item) {
              return [
                _c(
                  "yxt-button",
                  {
                    key: item.label,
                    attrs: {
                      disabled: item.disabled ? item.disabled() : false,
                      size: "large",
                      plain: item.plain,
                      type: item.type,
                    },
                    on: { click: item.action },
                  },
                  [_vm._v("\n          " + _vm._s(item.label) + "\n        ")]
                ),
              ]
            }),
            _c(
              "div",
              { staticClass: "flex-1 flex flex-mid ml16" },
              [
                _vm.arrangeInfo.uemAdding !== 0
                  ? [
                      _c("yxt-svg", {
                        staticClass: "color-gray-7",
                        attrs: {
                          width: "16px",
                          height: "16px",
                          "icon-class": "sync",
                        },
                      }),
                      _c(
                        "span",
                        { staticClass: "font-size-14 color-gray-9 ml8" },
                        [
                          _vm._v(
                            _vm._s(_vm.$t("pc_biz_ote_lbl_syncstu")) + "..."
                          ),
                        ]
                      ),
                    ]
                  : _vm._e(),
              ],
              2
            ),
            _vm.groupSelect
              ? _c("yxtbiz-group-org-select", {
                  staticClass: "mr12",
                  attrs: {
                    placeholder: _vm.$t("pc_biz_ote_lbl_plsselectorg"),
                    multiple: false,
                  },
                  on: { change: _vm.changeOrg },
                })
              : _vm._e(),
            _c("yxt-input", {
              staticClass: "width240 ml12",
              attrs: {
                placeholder: _vm.$t("pc_biz_ote_lbl_practiceusersearch"),
                searchable: "",
                maxlength: "20",
              },
              on: {
                search: function ($event) {
                  return _vm.search(1)
                },
              },
              model: {
                value: _vm.params.name,
                callback: function ($$v) {
                  _vm.$set(_vm.params, "name", $$v)
                },
                expression: "params.name",
              },
            }),
          ],
          2
        ),
        _c(
          "div",
          { staticClass: "participants-drawer--main" },
          [
            _c("common-table", {
              staticClass: "mt16",
              attrs: {
                "table-data": _vm.tableData,
                "column-configs": _vm.columnConfigs,
                "table-operation": _vm.tableOperation,
                loading: _vm.loading,
                selectable: true,
                selected: _vm.multiSelection,
              },
              on: {
                "update:selected": function ($event) {
                  _vm.multiSelection = $event
                },
              },
              scopedSlots: _vm._u([
                {
                  key: "userName",
                  fn: function (ref) {
                    var data = ref.data
                    return [_c("span", [_vm._v(_vm._s(data.userName))])]
                  },
                },
                {
                  key: "fullName",
                  fn: function (ref) {
                    var data = ref.data
                    return [
                      _c(
                        "div",
                        { staticClass: "flex flex-mid" },
                        [
                          _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                effect: "dark",
                                placement: "top",
                                "popper-class": "yxtbiz-participants-max-tip",
                                "open-filter": true,
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: data.fullName },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "ellipsis" },
                                [
                                  _c("yxtbiz-user-name", {
                                    attrs: { name: data.fullName },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                          data.udpDeleted === 1
                            ? _c(
                                "yxt-tag",
                                {
                                  staticClass: "ml5 ote-table-row__tag",
                                  attrs: { type: "info", size: "mini" },
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.$t("pc_biz_ote_lbl_deleted")) +
                                      "\n            "
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  },
                },
                {
                  key: "deptName",
                  fn: function (ref) {
                    var data = ref.data
                    return [
                      data.deptName
                        ? _c(
                            "yxt-tooltip",
                            {
                              attrs: {
                                placement: "top",
                                "open-filter": true,
                                "popper-class": "yxtbiz-participants-max-tip",
                              },
                            },
                            [
                              _c(
                                "div",
                                { attrs: { slot: "content" }, slot: "content" },
                                [
                                  _c("yxtbiz-dept-name", {
                                    attrs: { name: data.deptFullName },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "div",
                                { staticClass: "ellipsis" },
                                [
                                  _c("yxtbiz-dept-name", {
                                    attrs: { name: data.deptName },
                                  }),
                                ],
                                1
                              ),
                            ]
                          )
                        : _c("span", [_vm._v("--")]),
                    ]
                  },
                },
              ]),
            }),
            _c(
              "div",
              { staticClass: "flex flex-right mt16" },
              [
                _vm.pageData.count > 0
                  ? _c("yxt-pagination", {
                      attrs: {
                        "page-size": _vm.params.limit,
                        total: _vm.pageData.count,
                        "current-page": _vm.params.current,
                        layout: "total, prev, pager, next",
                      },
                      on: { "current-change": _vm.search },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c("users-selector", {
        ref: "userSelector",
        attrs: {
          groupSelect: _vm.groupSelect,
          "permission-code": "exam_add_appointCandidate_extent",
          id: _vm.arrangeId,
          batchId: _vm.batchId,
          projectId: _vm.projectId,
          taskId: _vm.taskId,
        },
        on: { didSelect: _vm.doSelectUsers },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }